import withAuth from './withAuth'
import ProtectedRoute from './ProtectedRouteBase'

const mapAuthToProps = (auth = {}) => ({
  session: auth.session,
  onUnauthenticated: auth.login,
})

export default withAuth(mapAuthToProps)(ProtectedRoute)
